module.exports = __webpack_public_path__ + "img/jpg-download-icon.e03d84f7.png";